import { useSessionStore } from '@/stores/SessionStore.ts';
import type { RequestTransferTokenResponseDto } from '../../../@generated/api-client';
import { apiService } from '@/services/ApiService.ts';
import { createTextToast } from '@/utils/ToastUtils.ts';

export const transferToBrowserAction = async (redirectUrl: string) => {
    const sessionStore = useSessionStore();
    sessionStore.isFullLoading = true;

    let apiResponse: RequestTransferTokenResponseDto;
    try {
        apiResponse = await apiService.getApi().authRequestTransferTokenV1({
            requestTransferTokenRequestDto: {
                redirectUrl,
            },
        });
    } catch {
        sessionStore.isFullLoading = false;

        createTextToast(
            'Failed to request transfer token',
            'Please try again',
            'destructive',
            false,
        );

        return;
    }

    sessionStore.isFullLoading = false;

    window.open(
        `${import.meta.env.VITE_WEB_VIEW_BASE_URL}/web-view/transfer?t=${apiResponse.token}`,
        '_blank',
    );
};
